import { FormControl, FormLabel, Input, Textarea } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { FaSave, FaTrashAlt } from 'react-icons/fa'
import { MdClose } from 'react-icons/md'
import Modal from 'react-modal'
import { MetaButton } from '../../../../../components/Buttons/MetaButton'
import { iPerguntasFrequentes } from '../../../../../interfaces'
import { ModalBody, ModalHeader, ModalFooter } from './styles'

interface props {
  isOpen: boolean
  pergunta?: iPerguntasFrequentes
  onRequestClose: () => void
  Create: (titulo: string, descricao: string) => void
  Update: (titulo: string, descricao: string) => void
  Delete: () => void
}

export const ModalTopico: React.FC<props> = ({ isOpen, pergunta, onRequestClose, Create, Update, Delete }) => {
  Modal.setAppElement('#root')
  const [Titulo, setTitulo] = useState('')
  const [Descricao, setDescricao] = useState('')

  useEffect(() => {
    if (pergunta) {
      setTitulo(pergunta.titulo)
      setDescricao(pergunta.descricao)
    }
  }, [pergunta])

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName='react-modal-overlay'
      className='react-modal-content-default'
    >
      <ModalHeader>
        <h2>{pergunta ? 'Editar tópico' : 'Adicionar tópico'}</h2>
        <MdClose size={24} onClick={onRequestClose} />
      </ModalHeader>

      <ModalBody>
        <FormControl marginBottom='1rem'>
          <FormLabel fontSize={'xl'}>Título</FormLabel>
          <Input borderColor={'var(--Gray4)'} value={Titulo} onChange={(e) => setTitulo(e.target.value)} placeholder='Digite um título para o tópico' type={'text'} />
        </FormControl>

        <FormControl>
          <FormLabel fontSize={'xl'}>Descricão</FormLabel>
          <Textarea borderColor={'var(--Gray4)'} value={Descricao} onChange={(e) => setDescricao(e.target.value)} placeholder='Digite uma pergunta para o tópico' />
        </FormControl>
      </ModalBody>

      <ModalFooter>
        {
          (pergunta) && (
            <MetaButton
              bg='terc1'
              size='md'
              onClick={Delete}
            ><FaTrashAlt className='IconLeft' />Remover</MetaButton>
          )
        }
        {
          pergunta
            ? <MetaButton
              bg='v2'
              size='md'
              onClick={() => Update(Titulo, Descricao)}
            ><FaSave className='IconLeft' />Salvar</MetaButton>
            : <MetaButton
              bg='v2'
              size='md'
              onClick={() => Create(Titulo, Descricao)}
            ><FaSave className='IconLeft' />Salvar</MetaButton>
        }
      </ModalFooter>
    </Modal>
  )
}
